import React, { useEffect, useState } from "react";

const PHASES = [
  "Discover",
  "Diagnose",
  "Design",
  "Plan",
  "Mobilise",
  "Deliver",
  "Embed",
  "Optimise",
];

/**
 * Cycling EKSELENS360 phases — slow fade-through one phase at a time, with the full
 * sequence shown below as quiet context. Sits inside the hero, just above the CTAs.
 */
const CyclingPhases = () => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setIdx((i) => (i + 1) % PHASES.length), 2200);
    return () => clearInterval(id);
  }, []);

  return (
    <div data-testid="cycling-phases" className="mt-10 mb-2 select-none">
      <div className="flex items-center gap-3 mb-3">
        <span className="w-8 h-px bg-[#A179FA]" />
        <span className="text-[10px] font-semibold tracking-[0.24em] uppercase text-[#A179FA]">
          The EKSELENS360 lifecycle
        </span>
      </div>

      <div className="flex items-baseline gap-3">
        <div
          className="relative inline-block"
          style={{ minWidth: "10ch" }}
        >
          <span
            key={idx}
            className="ek-heading text-2xl md:text-3xl text-white"
            style={{
              display: "inline-block",
              animation: "ek-phase-fade 2.2s ease-in-out",
            }}
          >
            {PHASES[idx]}
          </span>
        </div>
        <span className="text-zinc-400 text-sm md:text-base font-light hidden md:inline">
          —&nbsp;{PHASES.map((p) => (idx === PHASES.indexOf(p) ? p.toUpperCase() : p)).join("  ·  ")}
        </span>
      </div>

      <style>{`
        @keyframes ek-phase-fade {
          0%   { opacity: 0; transform: translateY(8px); }
          15%  { opacity: 1; transform: translateY(0); }
          85%  { opacity: 1; transform: translateY(0); }
          100% { opacity: 0; transform: translateY(-6px); }
        }
      `}</style>
    </div>
  );
};

export default CyclingPhases;
